import { useEffect, useState } from "react";
import CardCarousel from "./CardCarousel";
import s from "./TopAndRecommend.module.scss";
import titleImage from "../../../assets/images/titleImage.png";
import { faCrown, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import api from "../../../api/client";
import LoadingInside from "../../../components/Loading/LoadingInside";
import {TouchAppOutlined} from "@mui/icons-material";

const TopAndRecommend = () => {

    const [customSections, setCustomSections] = useState([]);
    const [activeTab, setActiveTab] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {

        const fetchTours = async () => {

            setLoading(true);

            try {

                const response = await api.get("/api/tours");

                const sections = response.data.customSections || [];

                setCustomSections(sections);

                // Select first section by default
                if (sections.length > 0) {
                    setActiveTab(sections[0].slug);
                }

            } catch (error) {

                console.error(error);
                setError("Failed to load tours.");

            } finally {

                setLoading(false);

            }
        };

        fetchTours();

    }, []);


    if (loading) {
        return <LoadingInside height={500} />;
    }


    if (error) {
        return (
            <div className="alert alert-danger">
                {error}
            </div>
        );
    }


    if (!customSections.length) {
        return null;
    }


    // Get currently selected section
    const activeSection = customSections.find(
        section => section.slug === activeTab
    );


    return (
        <div className="row mt-5 mb-5">

            {/* TITLE */}
            <div className="col-12">

                <h2>
                    <img
                        className={s.titleImage}
                        src={titleImage}
                        alt=""
                    />

                    ケアンズツアーおすすめ
                </h2>

            </div>


            <div className="col-12">

                {/* BUTTONS */}
                <div className={` ${s.tabSection} mt-3 mb-4`}>

                    {customSections.slice(0, 2).map(
                        (section, index) => (

                            <button
                                key={section.id}
                                type="button"
                                className={`btn px-4 py-2 ${s.navButtons} ${
                                    activeTab === section.slug
                                        ? s.navButtonsActive
                                        : ""
                                }`}
                                onClick={() =>
                                    setActiveTab(section.slug)
                                }
                            >

                                <FontAwesomeIcon
                                    icon={
                                        index === 0
                                            ? faCrown
                                            : faStar
                                    }
                                    className="me-2"
                                />

                                {section.name}

                            </button>

                        )
                    )}

                    <div className={s.navButtonIntro}>
                        <div>
                            <TouchAppOutlined/>
                        </div>
                        <div className={s.introText}>
                            タブを切り替えて、あなたにぴったりのツアーを見つけてください!
                        </div>

                    </div>

                </div>


                {/* SAME CAROUSEL */}
                {activeSection && (
                    <CardCarousel
                        tours={activeSection.tours}
                    />
                )}

            </div>

        </div>
    );
};

export default TopAndRecommend;